import DeepAnalysisError from "@/domain/entities/vistassistant/DeepAnalysisError";
import type { AppEvents } from "@cs_teamwaydev/mailvista-sdk_react";

// Keeps the userRequestId sent by the SDK: the error is shown under the answer it belongs to (F-0.5).
const deepAnalysisErrorMapper = ({
    userRequestId,
    error,
}: AppEvents["analysis-agent-error"]): DeepAnalysisError =>
    new DeepAnalysisError({
        userRequestId,
        error,
    });

export default deepAnalysisErrorMapper;
